module.exports = __webpack_public_path__ + "img/guide-andorid@2x.7f2e0bef.jpg";